import { createSelector as createOrmSelector } from 'redux-orm'
import { createSelector } from 'reselect'

import { Fields } from 'models/Modifier'
import orm from 'models/orm'
import { selectPagination } from './pagination'

export const selectModifiers = createOrmSelector(
  orm,
  (state: any) => state.orm,
  (session: any): Fields[] => {
    return session.Modifier.all().toRefArray() || []
  }
)

export const selectPaginatedModifiers = createSelector(
  selectModifiers,
  (state: any) => state,
  (_state: any, page: number) => page,
  (modifiers: Fields[], state: any, page: number): Fields[] => {
    const pagination = selectPagination(state, 'modifier', 'all')
    const recordIds = pagination?.record_ids?.[page] ?? []
    return modifiers.filter(modifier => recordIds.includes(modifier.uid))
  }
)
